/* eslint-disable prefer-const */
import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {AssetDataValidationModel, AssetService} from "../../asset/asset.service";
import {AssetRemovalService} from "../../asset/asset-removal.service";
import {AccessoryService} from "../../accessory/accessory.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStep} from "../workflow-step";
import {DeploymentService} from "../../deployment/deployment.service";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {SelectableAsset, selectableAssetModelListFactory} from "../../types/selectable-asset";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {addressDifferenceListFactory} from "../../address/address.model";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogShowSiteDifferencesComponent, ShowSiteDiffDialogModel} from "./dialog-show-site-differences.component";
import {ItsmContactModel, itsmContactModelListFactory} from "../../contact/itsm-contact.model";
import {ItsmAddressModel, ItsmProjectSettableAddressesModel, itsmProjectSettableAddressesModelFactory} from "../../address/itsm-address.model";
import {SiteService} from "../../sites/site.service";
import {ProjectService} from "../../project/project.service";
import {AssetAvailableDeviceModel, AssetGqlModel} from "../../asset/asset.gql-model";
import {
  DropdownsModel,
  ListSiteGroupModel,
  PurchaseOrderModel,
  SiteContactsModel,
  SiteContractModel,
} from "../site/assets-dropdowns-info-model";
import {SiteWorkflowService} from "../site/site-workflow.service";
import {DataFromEditAssetModel} from "../site/individual-site-design.component";
import {MultiError} from "../../errors/multi-error";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {ConfirmDialogService} from "../../confirm-dialog/confirm-dialog-service";
import {get} from "lodash";
import _ = require("lodash");
import {ProjectModel} from "../../project/project.model";
import {StandaloneAccessoryGqlModel} from "../../accessory/standalone-accessory.gql-model";
import {SoftwareGqlModel, SoftwareInputDataGqlModel} from "../../software/software.gql-model";
import {DataFromEditAccessoryModel} from "../../asset/edit-asset.component";
import {CostCenterModel} from "../../cost-center/cost-center.model";
import {CostCenterService} from "../../cost-center/cost-center.service";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {BillFromValue} from "../../bill-from/bill-from-with-region.model";
import {BillFromService} from "../../bill-from/bill-from.service";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { TARGET_SYSTEM } from "../../helpers/app-constants";
import { masterAgreementStatusValues } from "../../project/master-agreement-status";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;
function tokenizeString(str, tokenizers = "\\s") {
  if (!str) return [];
  const regex = new RegExp(`(?:[^${tokenizers}"]+|"[^"]*")+`, "g");
  return str.match(regex);
}

function stripQuotes(str) {
  if (!str || !str.trim()) return "";
  const result = str.match(/^"(.*)"$/);
  if (result && result.length > 1) return result[1];
  return str;
}

function cleanParam(param = "") {
  const clean = ((typeof param) !== "string") ? `${param}` : param;
  return clean.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}

@Component({
  templateUrl: "./deploy-devices.template.pug",
  providers: [
    DeploymentService,
    DeploymentWorkflowService,
    AssetService,
    AssetRemovalService,
    AccessoryService,
    DialogService,
    SiteWorkflowService,
    ConfirmDialogService,
    SiteService,
    BillFromService,
    HasuraGraphqlService,
  ],
})
export class DeployDevicesComponent extends WorkflowStep {
  projectId: string;
  deploymentId: string;
  error: Error;
  assets: SelectableAsset[] = [];
  filterAssets: SelectableAsset[] = [];
  displayAssets: SelectableAsset[] = [];
  deployment: any = {};
  siteDifferences: any[] = [];
  targetSystem: string;
  selectedIndex: number = -1;
  assetOpened: boolean = false;
  showRejectedWarning: boolean = false;
  assetChanged: boolean = false;
  currentAsset: AssetGqlModel = new AssetGqlModel({});
  currentAssetChanged: AssetGqlModel = new AssetGqlModel({});
  currentDevice: AssetAvailableDeviceModel = new AssetAvailableDeviceModel({});
  currentAccessory: StandaloneAccessoryGqlModel = new StandaloneAccessoryGqlModel({});
  currentSoftware: SoftwareGqlModel = new SoftwareGqlModel({});
  currentDeviceType: string = "";
  groupList: ListSiteGroupModel[];
  siteContactsList: SiteContactsModel[];
  dropdowns: DropdownsModel;
  successfulSave: boolean;
  disableCOAEditableLink: boolean = false;
  CR923: boolean = false;
  POR954_TMC: boolean;
  internalLoading: boolean = false;
  stepName: string;
  public project: ProjectModel;
  processingAsset: boolean = false;
  accountDetails;
  public itsmCustomInformation;
  public enableCustomFieldsFlag: boolean = false;
  public enableMultipleCA: boolean = false;
  public siteContract: SiteContractModel[];
  public itsmContractAccount: {"cId": string, "name": string} [] = [];
  public billFromAccounts: BillFromValue[];
  public showBillFrom: boolean = false;
  public enableAssetColorsFlag: boolean = false;
  public enablePOR0241: boolean = false;
  enableBillFrom: any;

  ContractualContactTypes: any = {
    billTo: [],
    accDelMgr: [],
    contractAdmin: [],
    hpInvoice: [],
    sales: [],
    invoice: [],
  };

  itsmContacts: any = [];
  itsmContactsWithItsmIds: any [];
  itsmContactsWithBpId: any = [];
  nonHpItsmContactsWithBpId: any = [];
  itsmContactsWithBpIdMap: any = {};

  solutionTypes = {
    asset: "Device",
    accessory: "Accessory",
    software: "Software",
    "asset removal": "Asset Removal",
  };

  assetStateList = [
    {key: "missing-information", text: "Missing or invalid asset details", color: "#eb9b03", icon: "warning"},
    {key: "ready", text: "Ready to upload", color: "#000000", icon: "none"},
    {key: "future-install-date", text: "Project don't allow future install date", color: "#6f1212", icon: "error"},
    {key: "upload-failed", text: "Upload failed", color: "#6f1212", icon: "error"},
    {key: "exists-in-k2", text: "Device is in K2", color: "#0f590f", icon: "ok"},
    {key: "found-in-k2", text: "Device was found in K2", color: "#0f590f", icon: "ok"},
    {key: "removal-in-k2", text: "Device was removed from K2", color: "#0f590f", icon: "ok"},
    {key: "validated", text: "Dry Run Successful", color: "#000000", icon: "none"},
    {key: "found-in-itsm", text: "Device was found in ITSM", color: "#0f590f", icon: "ok"},
    {key: "rejected-asset", text: "Rejected", color: "#FF0000", icon: "error"},
  ];

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  searchText: string = "";

  hideDataFullAssets: boolean = true;
  hideCompletedAssets: boolean = true;

  // ITSM data
  public itsmDataReady = false;
  itsmAddressInfo: ItsmProjectSettableAddressesModel;
  settableAddresses: ItsmAddressModel[] = [];
  settableAddressesMap: any = {};
  settableAddressesWithItsmBuildingIds: ItsmAddressModel[] = []; // Only send these addresses to the dialog
  itsmSiteContacts: ItsmContactModel[] = [];
  itsmSiteContactsMap: any = {};
  itsmSiteContactsWithItsmId: ItsmContactModel[] = [];
  itsmSiteContactsForSelectedDevice: ItsmContactModel[] = [];
  purchasOrdersList: PurchaseOrderModel[];
  softwareSaved: boolean = false;
  public devicesAssoc: object = {};
  public itsmCustomerId: string = "";
  public costCenters: CostCenterModel[] = [];

  public assetAssociations = {
    accessories: 0,
    software: 0,
  };

  public defaultContacts = {
    serviceAddressId: null,
    tonerAddressId: null,
  };

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentService: DeploymentService,
    public deploymentWorkflowService: DeploymentWorkflowService,
    private dialogService: DialogService,
    public assetService: AssetService,
    public assetRemovalService: AssetRemovalService,
    public accessoryService: AccessoryService,
    public siteService: SiteService,
    public projectService: ProjectService,
    public siteWorkflowService: SiteWorkflowService,
    private confirmDialogService: ConfirmDialogService,
    private costCenterService: CostCenterService,
    private appSettingsService: AppSettingsService,
    private billFromService: BillFromService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super(true);
    this.saveOnContinue = true;
  }

  private recalculateMaxPages() {
    this.maxPages = Math.ceil(this.filterAssets.length / (+this.pageSize));
  }

  loadDeploymentData() {
    this.clearAndCloseCurrentAsset();

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.filterAssets = this.assets.filter((asset) => {
      if (this.searchText) {
        const values = [
          asset.id,
          asset.serialNumber,
          asset.assetTag,
          asset.building,
          asset.floor,
          asset.floorMapId,
          asset.productNumber,
          asset.deviceKey,
          asset.friendlyName,
        ];

        const searchFailures = tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => stripQuotes(v)) // strip quotes on ends if present
          .map(v => cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }

      if(asset.statusKey === "rejected-asset") {
        this.hideDataFullAssets = false;
      }

      if (this.hideDataFullAssets && asset.statusKey !== "missing-information") return false;
      if (
        this.hideCompletedAssets &&
        (
          asset.statusKey === "exists-in-k2" ||
          asset.statusKey === "found-in-k2" ||
          asset.statusKey === "removal-in-k2"
        )
      ) return false;

      return true;
    });
    this.displayAssets = this.filterAssets.slice(start, end);
    this.recalculateMaxPages();
  }

  @handleErrors()
  async showContent(index: number, asset: SelectableAsset) {
    if (this.selectedIndex === index) return;

    if (this.assetChanged) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save({asset: this.currentAssetChanged, changes: this.assetChanged});
          if (!this.successfulSave) return;
          break;
        case "continue":
          this.clearAndCloseCurrentAsset();
          break;
        case "cancel":
          return;
        default:
          break;
      }
    }
    this.assetOpened = true;
    await this.setSolutionData(asset);
    if (this.currentDeviceType === "asset") {
      await this.loadDeviceDropdownsData(this.currentAsset.siteId);
    }
    this.selectedIndex = index;
  }

  @handleErrors()
  async setSolutionData(asset: SelectableAsset) {
    if (asset.type === "asset") {
      this.currentAsset = await this.assetService.getAsset(asset.id);
      const params: any = `
        countryId
        billFromStructure
        `;
      const projectInfo = await this.projectService.getProjectDetails(this.projectId, params);
      if(!this.enableBillFrom || projectInfo.countryId != 'IN'){
        if(this.currentAsset.software){
          for(let software of this.currentAsset.software){
            delete software['billFromBPIDId'];
          }
        }
      }
      // Filter and fill Contacts for Selected Device Array
      this.itsmSiteContactsForSelectedDevice = this.itsmSiteContactsWithItsmId.filter(contact => (
        !contact.siteId ||
        (this.currentAsset.siteId && contact.siteId === this.currentAsset.siteId)
      ));
      this.currentDevice = await this.currentAsset.availableDevices.find(d => d.id === this.currentAsset.deviceId);
    } else if (asset.type === "accessory") {
      this.currentAccessory = await this.accessoryService.getAccessory(asset.id);
      if (!this.currentAccessory.contractAccountId && this.siteContract && this.siteContract.length) {
        this.currentAccessory.contractAccountId = this.siteContract[0].contractAccountId;
      }
    } else {
      this.currentSoftware = await this.assetService.getSoftware(asset.id);
      if (!this.currentSoftware.contractAccountId && this.siteContract && this.siteContract.length) {
        this.currentSoftware.contractAccountId = this.siteContract[0].contractAccountId;
      }
    }
    this.currentDeviceType = asset.type;
  }

  @handleErrors()
  async individualAccessoryChange(data: DataFromEditAccessoryModel) {
    if (data.errors) throw new Error(data.errors);
    this.assetChanged = data.changes;
    if (!data.accessories[0].keep) await this.remove(this.assets[this.selectedIndex]);
  }

  individualSoftwareChange(data) {
    this.assetChanged = data.changes;
    if (data.changes) this.softwareSaved = false;
  }

  @handleErrors()
  async saveSoftware() {
    if (!this.currentSoftware.change) return false;
    const {updated} = await this.assetService.saveSoftware([
      new SoftwareInputDataGqlModel(this.currentSoftware),
    ]);
    this.currentSoftware.change = false;
    this.assetChanged = false;
    this.softwareSaved = true;

    try {
      this.loading = true;
      await this.loadData();
      this.clearAndCloseCurrentAsset();
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }

    return updated;
  }

  @handleErrors()
  async edit(asset: SelectableAsset, index?: number) {
    if (this.internalLoading) return;
    asset.isClicked = true;
    switch (asset.type) {
      case "asset":
      case "accessory":
      case "software":
        await this.showContent(index, asset);
        asset.isClicked = false;
        return;
      case "asset removal":
        await this.assetRemovalService.editAsset(asset.id, this.projectId);
        break;
      default:
        asset.isClicked = false;
        throw new Error("Could not edit this item.");
    }
    this.loading = true;
    await this.loadData();
    this.loading = false;
    asset.isClicked = false;
  }

  @handleErrors()
  async loadData(): Promise<void> {
    this.error = undefined;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    if (!this.deploymentId) return;

    const [
      featurePermissions,
      assetList
    ] = await Promise.all([
      this.appSettingsService.getFeaturePermissionsList(["enableMultipleCA", "POR024", "enableApolloProjectQuery", "enableCustomFields", "enableBillFrom"]),
      this.deploymentWorkflowService.getAssetListFromITSM(this.deploymentId).toPromise()      
    ]);

    const [
      multipleCA,
      POR024,
      enableApolloProjectQuery,
      enableCustomFields,      
      enableBillFrom,
      CR923
    ] = [
      featurePermissions["enableMultipleCA"],
      featurePermissions["POR024"],
      featurePermissions["enableApolloProjectQuery"],
      featurePermissions["enableCustomFields"],
      featurePermissions["enableBillFrom"],
      this.CR923
    ];
    const {rows, differingSites} = assetList;

    if (enableApolloProjectQuery) {
      /* const params: any = `
        id
        targetSystem
        itsmCustomerId
        countryId
        billFromStructure
      `;
      this.project = await this.projectService.getProjectDetails(this.projectId, params); */
      const params: any = `
        id
        targetSystem: target_system
        itsmCustomerId: itsm_customer_id
        countryId: country_id
        billFromStructure: bill_from_structure`;
        this.project = await this.hasuraGqlService.getProjectResponseFromHasura(this.workflowTargetInfo.projectId, params);
    } else {
      this.project = await this.projectService.getProjectById(this.projectId).toPromise();
    }

    this.itsmCustomerId = this.project.itsmCustomerId;

    this.assets = selectableAssetModelListFactory(rows, {});
    this.siteDifferences = addressDifferenceListFactory(differingSites);
    this.recalculateMaxPages();
    this.enableCustomFieldsFlag = enableCustomFields;
    this.enableMultipleCA = multipleCA && POR024;
    this.enableBillFrom = enableBillFrom;
    this.loadDeploymentData();
  }

  @handleErrors()
  async loadDeviceDropdownsData(siteId: string) {
    const {
      dropdownGroupsList,
      dropdowns,
      dropdownSiteContacts,
      dropdownPurchaseOrders,
      dropdownContractList,
    } = await this.siteWorkflowService.getAssetsDropdownData(siteId, this.projectId);
    this.groupList = dropdownGroupsList;
    this.siteContactsList = dropdownSiteContacts;
    this.purchasOrdersList = dropdownPurchaseOrders;
    this.dropdowns = dropdowns;
    this.siteContract = dropdownContractList;
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        break;
    }
    this.loadDeploymentData();
  }

  updateItsmAddressMapsHelper() {
    this.settableAddresses.sort((a, b) => {
      if ((a.itsmName || "").toLowerCase() > (b.itsmName || "").toLowerCase()) return 1;
      return -1;
    });
    this.settableAddressesMap = this.settableAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.settableAddressesWithItsmBuildingIds = this.settableAddresses.filter(it => it.itsmBuildingId);
  }

  updateItsmContactMapsHelper() {
    this.itsmSiteContacts.sort((a, b) => {
      if ((a.emailAddress || "").toLowerCase() > (b.emailAddress || "").toLowerCase()) return 1;
      return -1;
    });
    this.itsmSiteContactsMap = this.itsmSiteContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.itsmSiteContactsWithItsmId = this.itsmSiteContacts.filter(it => !!it.itsmContactId);
  }

  @handleErrors()
  async loadItsmData() {
    Query.DEPLOY_DEVICE.variables.projectId = this.projectId;
    const deployDeviceQueryParam = {
      projectId: this.projectId,
      query: Query.DEPLOY_DEVICE,
      uiAction: "DEPLOY-DEVICE",
    };

    Query.GLOBAL_OPP_ID.variables.projectId = this.projectId;
    const contactParams = {
      projectId: this.projectId,
      uiAction: "DEPLOY-DEVICE",
      queryType: "Global-Deal",
      query: Query.GLOBAL_OPP_ID,
    };

    Query.SITE_DEPLOYMENT.variables.id = this.deploymentId;
    const siteDeploymentParam = {
      projectId: this.projectId,
      uiAction: "DEPLOY-DEVICE",
      query: Query.SITE_DEPLOYMENT,
    };
    Query.PROJECT_SITES.variables.projectId = this.projectId;
    const projectSitesQuery = {
      projectId: this.projectId,
      uiAction: "PROJECT-SITES",
      query: Query.PROJECT_SITES,
    };
    this.error = undefined;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    if (!this.deploymentId) return;
    let multipleCA;
    let POR024;
    let enableApolloProjectQuery = false;
    let addressResponse;
    let assetListFromItsm;
    // let itsmAddressInfo;
    let tmcProjectDeployDevice;
    let POR89_2_flag = false;
    let POR89_2_TMC_flag = false;
    let POR024_1 = false;
    let contactResponse;
    let siteDeplyment;
    let featurePermissions;
    
    let projectSites;
    [
      featurePermissions, 
      assetListFromItsm,
      contactResponse,
      tmcProjectDeployDevice,     
      siteDeplyment,
      projectSites,
    ] = await Promise.all([
      this.appSettingsService.getFeaturePermissionsList(["enableMultipleCA", "POR024", "enableApolloProjectQuery", "enableCustomFields", "POR89-2", "POR89-2_TMC","POR024_1","CR923_COA_TMC"]),
      this.deploymentWorkflowService.getAssetListFromITSM(this.deploymentId).toPromise(),
      // this.siteService.getItsmSettableAddressesByProject(this.projectId),
      // this.projectService.getItsmContacts(this.projectId, true),
      this.hasuraGqlService.getResponseFromHasura(contactParams),
      // this.costCenterService.getCostCentersByProjectId(this.projectId),
      this.hasuraGqlService.getResponseFromHasura(deployDeviceQueryParam),      
      this.hasuraGqlService.getResponseFromHasura(siteDeploymentParam),
      this.hasuraGqlService.getResponseFromHasura(projectSitesQuery),
      this.loadFinancialContact(),
    ]);

    [ multipleCA,
      POR024,
      enableApolloProjectQuery,
      this.enableCustomFieldsFlag,
      POR89_2_flag,
      POR89_2_TMC_flag,
      POR024_1,
      this.CR923,
    ]=[
      featurePermissions["enableMultipleCA"],
      featurePermissions["POR024"],
      featurePermissions["enableApolloProjectQuery"],
      featurePermissions["enableCustomFields"],
      featurePermissions["POR89-2"],
      featurePermissions["POR89-2_TMC"],
      featurePermissions["POR024_1"],
      featurePermissions["CR923_COA_TMC"]
    ];
    this.enableAssetColorsFlag = POR89_2_flag || POR89_2_TMC_flag;
    this.enablePOR0241 = POR024_1;

    const {rows, differingSites} = assetListFromItsm;
    if (tmcProjectDeployDevice && tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter.cost_centers) {
      this.costCenters = tmcProjectDeployDevice.body.data.global_deal_settings[0].projectCostCenter.cost_centers;
    }

    if (enableApolloProjectQuery) {
      /* const params: any = `
        id
        targetSystem
        itsmCustomerId
        countryId
        billFromStructure
      `;
      this.project = await this.projectService.getProjectDetails(this.projectId, params); */
      const params: any = `
        id
        targetSystem: target_system
        itsmCustomerId: itsm_customer_id
        countryId: country_id
        billFromStructure: bill_from_structure`;
        this.project = await this.hasuraGqlService.getProjectResponseFromHasura(this.workflowTargetInfo.projectId, params);
    } else {
      this.project = await this.projectService.getProjectById(this.projectId).toPromise();
    }

    this.itsmCustomerId = this.project.itsmCustomerId;
    this.assets = selectableAssetModelListFactory(rows, {});
    this.showRejectedWarning = rows.some(asset => asset.statusKey === 'rejected-asset');
    this.siteDifferences = addressDifferenceListFactory(differingSites);
    this.recalculateMaxPages();
    if (this.enableCustomFieldsFlag && tmcProjectDeployDevice &&
      tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].project &&
      tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customHeaders) {
      const labelValues = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customHeaders || {};
      const customLabelArray = [];
      const keys = Object.keys(labelValues);
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        customLabelArray.push({number: i + 1, value: labelValues[key]});
      }
      this.itsmCustomInformation = customLabelArray;
    }
    this.enableMultipleCA = multipleCA && POR024;
    this.loadDeploymentData();
    if (siteDeplyment && siteDeplyment.body.data.site_deployment.length > 0 &&
      siteDeplyment.body.data.site_deployment[0].assets && siteDeplyment.body.data.site_deployment[0].assets.length > 0 ) {
      // const siteIds:any = [];
      let settableAddresses;
      const itsmSiteIds = projectSites.body.data.site.map(site => site.address.siteId);
      /* for(const asset of siteDeplyment.body.data.site_deployment[0].assets) {
          if(asset && asset.site && asset.site.address && asset.site.address.itsm_site_id) {
            siteIds.push(asset.site.address.itsm_site_id);
          }
      } */
      Query.DEPLOY_ADDRESS.variables.siteId = itsmSiteIds;
      const deployAddressParam = {
        projectId: this.projectId,
        query: Query.DEPLOY_ADDRESS,
        uiAction: "DEPLOY-DEVICE",
      };
      addressResponse = await this.hasuraGqlService.getResponseFromHasura(deployAddressParam);
      if (addressResponse && addressResponse.body.data && addressResponse.body.data.settableAddresses &&
        addressResponse.body.data.settableAddresses.length > 0) {
        let deployAddress: ItsmProjectSettableAddressesModel = {
          settableAddresses: addressResponse.body.data.settableAddresses,
          // tonerAddressId: siteDeplyment.body.data.site_deployment[0].site.toner_address_id,
          // serviceAddressId: siteDeplyment.body.data.site_deployment[0].site.service_address_id,
          // physicalAddressId: siteDeplyment.body.data.site_deployment[0].site.site_address_id,
        };
        deployAddress = itsmProjectSettableAddressesModelFactory(deployAddress);
        this.itsmAddressInfo = deployAddress;
        this.settableAddresses = deployAddress.settableAddresses;
        // this.defaultContacts.serviceAddressId = deployAddress.serviceAddressId;
        // this.defaultContacts.tonerAddressId = deployAddress.tonerAddressId;
      }
    }
    let contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    contacts = _.uniqBy(contacts, "itsmContactId");
    contacts = itsmContactModelListFactory(contacts);
    // contacts.forEach(item => item.name = `${item.firstName} ${item.lastName}`);
    let itsmSiteContacts;
    if (this.targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
      this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH) {
      itsmSiteContacts = contacts.filter((_contact) => {
        if (_contact.resellerCustomerId && _contact.relatedAccountIds &&
            _contact.relatedAccountIds.find(rc => rc === _contact.resellerCustomerId)) {
          return _contact;
        }
      });
    } else {
      itsmSiteContacts = contacts;
    }
    this.itsmSiteContacts = itsmSiteContacts && itsmSiteContacts.length ? itsmSiteContacts : [];
    this.updateItsmAddressMapsHelper();
    this.updateItsmContactMapsHelper();
    this.itsmDataReady = true;
    if (this.enableMultipleCA) {
      if (tmcProjectDeployDevice && tmcProjectDeployDevice.body.data.global_deal_settings.length > 0 &&
        tmcProjectDeployDevice.body.data.global_deal_settings[0].project &&
        tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system) {
        let contractAccountData = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "pmpsp" ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "mimp" ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === "mpflexr" ||
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.target_system === TARGET_SYSTEM.PMPS_SELL_THROUGH ?
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.partnerContractAccounts ?
            tmcProjectDeployDevice.body.data.global_deal_settings[0].project.partnerContractAccounts.contract_accounts :
            [] :
          tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customerContractAccounts ?
            tmcProjectDeployDevice.body.data.global_deal_settings[0].project.customerContractAccounts
              .contract_accounts : [];
        contractAccountData = contractAccountData.filter(it => it.status);
        const projectOpportunityId = tmcProjectDeployDevice.body.data.global_deal_settings[0].project.opportunityId;
        this.itsmContractAccount = contractAccountData.map((item) => {
          let contractAcct;
          if (this.enablePOR0241 && projectOpportunityId &&
            !item.contracts.find(contract => contract.opportunityId === projectOpportunityId)) {
            contractAcct = undefined;
          } else {
            contractAcct = {
              name: item.contractAccountName,
              cId: item.contractAccountId,
            };
          }
          return contractAcct;
        }).filter(account => account !== undefined);
      }
    }
    this.showBillFrom = await this.billFromService.showBillFrom(this.project) &&
      this.billFromService.isDecentralized(this.project);
    if (this.showBillFrom) {
      await this.loadBillFromBuildings();
    }
  }

  @handleErrors()
  async save(data: DataFromEditAssetModel) {
    // Update statusKey to readyToUpload if it was in rejected state
    if (data.asset.statusKey === "rejected-asset" && this.stepName === "deployDevices") {
      Query.UPDATE_ASSET_STATUS.variables.ids = data.asset.id;
      Query.UPDATE_ASSET_STATUS.variables.last_upload_result = {
        details: [],
        status: "ready",
      };
      const params = {
        query: Query.UPDATE_ASSET_STATUS,
        uiAction: "DEPLOY-DEVICE",
        projectId: this.projectId,
      };
      const updateAssetStatus = await this.hasuraGqlService.getResponseFromHasura(params);
    }
    this.successfulSave = false;
    this.processingAsset = true;
    let success;
    if (data.changes) {
      if (this.currentDeviceType === "asset") {
        const errors = await this.assetValidations(data.asset,this.enableAssetColorsFlag);
        if (errors.length) {
          const multiError = new MultiError("");
          multiError.errors = errors;
          this.error = multiError;
          this.processingAsset = false;
          return;
        }

        const {updated} = await this.assetService.saveAsset(data.asset);
        success = updated;
      } else if (this.currentDeviceType === "accessory") {
        const {updated} = await this.accessoryService.saveAccessory(this.currentAccessory);
        success = updated;
      } else success = await this.saveSoftware();

      if (success) {
        // commented part of performance chnages
        // this.costCenters = await this.costCenterService.getCostCentersByProjectId(this.projectId);
        await this.loadData();
        this.successfulSave = true;
      }
      this.internalLoading = false;
    }
    this.processingAsset = false;
    this.clearAndCloseCurrentAsset();
  }

  async closeDetails(data: DataFromEditAssetModel) {
    if (data.changes) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save(data);
          break;
        case "continue":
          this.clearAndCloseCurrentAsset();
          break;
        case "cancel":
        default:
          break;
      }
    } else {
      this.clearAndCloseCurrentAsset();
    }
  }

  @handleErrors()
  async remove(asset: SelectableAsset) {
    const doRemove = await this.confirmDialogService.confirm(
      "Confirm Removal",
      "Are you sure you want to remove this item?",
    );
    if (!doRemove) return;

    if (this.currentDeviceType === "asset") {
      this.checkDeviceIsAssociated(asset);
      await this.assetService.deleteById(asset.id);
    } else if (this.currentDeviceType === "accessory") {
      await this.accessoryService.deleteAccessory(asset.id);
      if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
    } else {
      await this.assetService.deleteSoftware(asset.id);
      if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
    }

    await this.loadData();
    this.selectedIndex = -1;
  }

  checkDeviceIsAssociated(asset: SelectableAsset) {
    const association = this.assets.find(a => a.type !== "asset" && a.assetId === asset.id);
    if (association) throw Error("This device is associated with another solution and it can't be deleted.");
  }

  async currentAssetChangeDetected(data: DataFromEditAssetModel) {
    const accessoriesAssociationChange = this.assetAssociations.accessories !== data.asset.standaloneAccessories.length;
    const softwareAssociationChange = this.assetAssociations.software !== data.asset.software.length;

    if (accessoriesAssociationChange || softwareAssociationChange) {
      this.checkSolutionsAssociationChanges(data.asset, accessoriesAssociationChange);
    }

    this.currentAssetChanged = new AssetGqlModel(data.asset);
    this.assetChanged = data.changes;
  }

  checkSolutionsAssociationChanges(asset: AssetGqlModel, accessories: boolean) {
    this.assetAssociations.accessories = asset.standaloneAccessories.length;
    this.assetAssociations.software = asset.software.length;

    const solution = accessories ? "accessory" : "software";
    const solutionsIds = accessories ?
      asset.standaloneAccessories.reduce((acc, it) => {
        acc[it.id] = "0";
        return acc;
      }, {}) :
      asset.software.reduce((so, it) => {
        so[it.id] = "0";
        return so;
      }, {});

    this.assets.forEach((a) => {
      if (a.type === solution) {
        if (!a.assetId && solutionsIds[a.id]) {
          a.assetAssociatedName = this.assets[this.selectedIndex].description;
          a.assetId = asset.id;
          this.setDeviceAssociation(a);
        } else if (a.assetId === asset.id && !solutionsIds[a.id]) {
          if (this.devicesAssoc[a.assetId][a.type] > 0) this.devicesAssoc[a.assetId][a.type] -= 1;
          a.assetAssociatedName = null;
          a.assetId = null;
        }
      }
    });
  }

  setDeviceAssociation(solution: SelectableAsset) {
    if (!this.devicesAssoc[solution.assetId]) {
      this.devicesAssoc[solution.assetId] = {[solution.type]: 1};
    } else if (!this.devicesAssoc[solution.assetId][solution.type]) {
      this.devicesAssoc[solution.assetId][solution.type] = 1;
    } else this.devicesAssoc[solution.assetId][solution.type] += 1;
  }

  async assetValidations(asset: AssetGqlModel,  enablePOR089_2 = false) {
    const assetForValidation: AssetDataValidationModel = {
      installDate: asset.installDate,
      orderDate: asset.orderDate,
      initialPageCountColor: asset.initialPageCountColor,
      initialPageCountColorProfessional: asset.initialPageCountColorProfessional,
      initialPageCount: asset.initialPageCount,
      initialPageCountColorGeneralOffice: asset.initialPageCountColorGeneralOffice,
      initialPageCountColorAccent: asset.initialPageCountColorAccent,
      initialPageCountOther: asset.initialPageCountOther,
      printCapability: asset.printCapability,
    };

    return await this.assetService.assetDataValidations(assetForValidation,false,enablePOR089_2);
  }

  clearAndCloseCurrentAsset() {
    this.assetOpened = false;
    this.assetChanged = false;
    this.selectedIndex = -1;
    this.currentAsset = new AssetGqlModel({});
    this.currentDevice = new AssetAvailableDeviceModel({});
  }

  async fileUploaded() {
    this.clearAndCloseCurrentAsset();
    await this.loadData();
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    const assetIds = this.assets
      .filter(asset => !asset.installed)
      .map(asset => asset.id);
  
    // Prepare the body
    Query.GET_INITIAL_PAGE_COUNT.variables.assetIds = assetIds;
    const body = {
      query: Query.GET_INITIAL_PAGE_COUNT,
      uiAction: "DEPLOY-DEVICE",
      projectId: this.projectId,
    };
  
    // Execute the GraphQL query using HasuraGraphqlService
    const response = await this.hasuraGqlService.getResponseFromHasura(body);

    // Check if InitialPageCount is 0 for any asset and if installDate is at least 1 day from today
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);

    const hasDelayedAsset = response.body.data.asset.some(asset => {
      if (asset.initial_page_count === null && asset.install_date) {
        const installDate = new Date(asset.install_date);
        installDate.setUTCHours(0, 0, 0, 0);
        const diffDays = (today.getTime() - installDate.getTime()) / (1000 * 60 * 60 * 24);
        return diffDays >= 1;
      }
      return false;
    });
  
    if (hasDelayedAsset) {
      const userResponse = await this.confirmDialogService.confirm(
        "Warning",
        `One or more devices have a past install date and are missing initial page count information. Please update the initial page count for these devices if available, or click 'OK' to proceed without updating.`,
      );
      if (!userResponse) {
        return false;
      }
    }
  
    return true;
  }
  
  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.loading = true;
    this.projectId = this.workflowService.workflowConfig.projectId;
    this.stepName = get(this.workflowService.currentStep, "stepName");
    this.deploymentId = workflowTargetInfo.targetId;
    // await this.loadData();
    await this.loadItsmData();
    this.loading = false;
  }

  async viewDifferingSites() {
    await DialogShowSiteDifferencesComponent.showSiteDifferencesDialogModal(
      this.dialogService, {siteDifferences: this.siteDifferences} as ShowSiteDiffDialogModel,
    );
  }

  checkDirty(): boolean {
    return this.assetChanged;
  }

  private async loadBillFromBuildings() {
    this.billFromAccounts = await this.billFromService.getBillFromBuildings(
      this.projectId,
      this.project.country.countryId,
    );
  }

  async loadFinancialContact() {
    this.POR954_TMC = await this.appSettingsService.getFeaturePermission("POR954_TMC", this.projectId);
    if(this.POR954_TMC) {
      await this.projectService.getItsmContacts(this.projectId, false, true);

    }
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
    };

    if (this.targetSystem === "pmpsp" || this.targetSystem === "mimp" ||
    this.targetSystem === "mpflexr" || this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      params.query = this.POR954_TMC ? Query.PARTNER_CONTACTS_WITH_ACTIVE_FILTER : Query.PARTNER_CONTACTS;
    } else {
      params.query = this.POR954_TMC ? Query.CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER : Query.CUSTOMER_CONTACTS;
    }
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);

    const contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) await this.getHpInvoiceContact(contacts);
   this.setItsmContacts(contacts);
    return this.itsmContacts;
  }
  setItsmContacts(contacts) {
    if (contacts.length) {
      contacts.forEach(contact => contact.name = `${contact.firstName} ${contact.lastName}`);
      this.itsmContacts = contacts;
      this.itsmContactsWithItsmIds = this.itsmContacts.filter(it => it.itsmContactId);
      this.itsmContactsWithBpId = contacts.filter(it => it.businessPartnerId);
      this.nonHpItsmContactsWithBpId = this.itsmContactsWithBpId.filter(it => !it.isHpContact);
      this.itsmContactsWithBpIdMap =
        this.itsmContactsWithBpId.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      this.buildContactTypes();
    }
  }
  buildContactTypes() {
    for (const contact of this.itsmContactsWithBpId) {
      if (!contact.isHpContact) {
        this.ContractualContactTypes.billTo.push(contact);
        this.ContractualContactTypes.invoice.push(contact);
      } else if (contact.contactTypes) {
        Object.keys(contact.contactTypes).forEach((type) => {
          if (type !== "billTo" && type !== "invoice" && this.ContractualContactTypes[type]) {
            this.ContractualContactTypes[type].push(contact);
          }
        });
      }
    }

    const contactTypesArray = Object.keys(this.ContractualContactTypes);
    for (const type of contactTypesArray) {
      if (!this.ContractualContactTypes[type].length && (type === "billTo" || type === "invoice")) {
        this.ContractualContactTypes[type] = this.nonHpItsmContactsWithBpId;
      } else if (!this.POR954_TMC && !this.ContractualContactTypes[type].length) this.ContractualContactTypes[type] = this.itsmContactsWithBpId;
    }
  }
  async getHpInvoiceContact(contacts) {
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
      query: Query.CUSTOMER_CONTACTS,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
    contacts.forEach((itm) => {
      if (itm.contactTypes && itm.contactTypes["hpInvoice"] === true) {
        itm.contactTypes["hpInvoice"] = false;
      }
    });
    const customerContacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    customerContacts.forEach((contact) => {
      if (contact.contactTypes && contact.contactTypes["hpInvoice"] === true) contacts.push(contact);
    });
  }
}
